import { get } from '../../utils/object-helpers';

const KEY = 'str-profile-edit-drawer';
export const DESCRIPTION_FIELD_NAME = 'aboutDescription';
export const CLS = {
    open: 'open',
    hideElements: 'str-profile-edit-buttons__hide-elements',
    preventScroll: 'str-profile-edit-buttons__prevent-scroll'
};
const SEL = {
    storeLogo: '.str-seller-card__store-logo'
};

export default class {
    onCreate(input) {
        const descEditModule = get(input, 'page.modules.ABOUT_DESCRIPTION_EDIT_MODULE', null);
        const descModule = get(input, 'page.modules.ABOUT_DESCRIPTION_MODULE', null);
        const module = descEditModule || descModule || {};
        const globalState = get(input, 'globalState', {});
        const subTitles = get(module, 'subTitles', []);

        this.isSmall = get(input, 'page.isSmall', false);
        this.editDebounceTimer = null;
        this.state = {
            about: subTitles.find(it => it.contentKey !== 'EDITABLE'),
            aboutEditDescription: subTitles.find(it => it.contentKey === 'EDITABLE'),
            profileEditState: this.getProfileEdit(globalState)
        };
    }
    onInput(input) {
        const descEditModule = get(input, 'page.modules.ABOUT_DESCRIPTION_EDIT_MODULE', null);
        const descModule = get(input, 'page.modules.ABOUT_DESCRIPTION_MODULE', null);
        const module = descEditModule || descModule || {};
        const globalState = get(input, 'globalState', {});

        // Update state
        const updatedAboutText = get(globalState, `profileEdit.payload.${DESCRIPTION_FIELD_NAME}`);
        if (updatedAboutText !== undefined) {
            this.state.about = {
                ...this.state.about,
                textSpans: [
                    {
                        ...this.state.about.textSpans[0],
                        text: updatedAboutText
                    }
                ]
            };
        }
        this.state.profileEditState = this.getProfileEdit(globalState);

        return {
            page: input.page,
            globalState,
            title: get(module, 'title', {}),
            titleText: get(module, 'title.textSpans.0.text', '')
        };
    }
    onMount() {
        this.root = this.getEl(KEY);
        setTimeout(() => {
            this.updateText(get(this.state.about, 'textSpans.0.text', ''));
        }, 0);
        this.positionTopOfDrawer();
    }
    onUpdate() {
        const editing = get(this.state.profileEditState, 'editing', '');
        if (!editing) {
            this.close();
        } else if (editing) {
            this.open();
        }
        this.positionTopOfDrawer();
    }
    handleTextUpdate(ev) {
        if (this.editDebounceTimer) {
            clearTimeout(this.editDebounceTimer);
            this.editDebounceTimer = null;
        }
        this.editDebounceTimer = setTimeout(() => {
            this.updateText(ev.target.value);
        }, 0);
    }
    updateText(value) {
        const eventDetail = {
            action: {
                name: 'UPDATE_PROFILE_FIELD'
            },
            payload: {
                field: DESCRIPTION_FIELD_NAME,
                value
            }
        };
        document.dispatchEvent(new CustomEvent('presenceEdit', { detail: eventDetail }));
    }
    getProfileEdit(globalState) {
        return get(globalState, 'profileEdit', {});
    }
    open() {
        if (this.root && !this.root.classList.contains(CLS.open)) {
            this.root.classList.add(CLS.open);
            this.handleFocusableElements(true);
        }
    }
    close() {
        if (this.root) {
            this.root.classList.remove(CLS.open);
            this.handleFocusableElements(false);
        }
    }
    // If error message appears above the header,
    // need to reposition the drawer.
    positionTopOfDrawer() {
        if (this.root) {
            const storeLogo = document.querySelector(SEL.storeLogo);
            if (storeLogo) {
                const height = storeLogo.offsetHeight;
                const boundingTop = storeLogo.getBoundingClientRect().top;
                this.root.style.top = `${height + boundingTop}px`;
            } else {
                this.root.style.top = '190px';
            }
        }
    }
    handleFocusableElements(isHide) {
        // When profile edit drawer is open, need to set the elements hidden
        // by drawer to display:none to prevent them getting focus.
        const selectors = [
            '.str-controlbar-wrap',
            '.str-shop-header__categories',
            'body > .app-layout',
            '.global-footer'
        ];
        const body = document.querySelector('body');
        if (this.isSmall && body) {
            if (isHide) {
                body.classList.add(CLS.preventScroll);
                selectors.forEach(sel => {
                    const el = document.querySelector(sel);
                    if (el) {
                        el.classList.add(CLS.hideElements);
                    }
                });
            } else {
                body.classList.remove(CLS.preventScroll);
                selectors.forEach(sel => {
                    const el = document.querySelector(sel);
                    if (el) {
                        el.classList.remove(CLS.hideElements);
                    }
                });
            }
        }
    }
}
